import React from 'react';
import cx from 'classnames';
import {withFormsy} from 'formsy-react';
import {Icon, SvgProps} from 'epic-diesel-common';
import {FormsyProps} from '../external/types';

//@ts-ignore
import styles from './Input.pcss';

interface InputProps extends Partial<FormsyProps> {
    forwardedRef?: {
        current: HTMLInputElement;
    };
    name: string;
    id?: string;
    value?: string | number;
    required?: boolean;
    mask?: string;
    pattern?: string;
    disabled?: boolean;
    className?: string;
    onMouseEnter?: VoidFunction;
    onMouseLeave?: VoidFunction;
    onChange: (event?) => void;
    type?:
        | 'date'
        | 'datetime'
        | 'email'
        | 'hidden'
        | 'number'
        | 'password'
        | 'range'
        | 'search'
        | 'tel'
        | 'text'
        | 'time'
        | 'url';
    placeholder?: string | object;
    icon?: SvgProps;
    iconClassName?: string;
}

@withFormsy
class Input extends React.Component<InputProps> {
    handleChange = event => {
        const {required, onChange} = this.props;
        let {value} = event.currentTarget;
        if (required && value === ' ') {
            value = '';
        }
        if (this.props.formatValue) {
            value = this.props.formatValue(value);
        }
        this.props.setValue(value);
        if (onChange) {
            event.currentTarget.value = value;
            onChange(event);
        }
    };

    renderErrorMessage = () => {
        if (!this.props.isPristine() && (this.props.showError() || !this.props.isValid())) {
            let errorMessage = this.props.getErrorMessage();

            if (!errorMessage && this.props.required) {
                errorMessage = this.props.defaultErrorMessage;
            }

            return errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>;
        }
    };

    static defaultProps = {
        className: styles.input
    };

    render() {
        const {
            id,
            name,
            type,
            value = '',
            mask = '',
            disabled,
            autoComplete,
            onMouseEnter,
            onMouseLeave,
            pattern,
            required,
            icon,
            iconClassName,
            forwardedRef,
            maxLength
        } = this.props;

        let {className, placeholder} = this.props;
        if (['hidden', 'range'].indexOf(type) !== -1) {
            className = null;
        } else if (value) {
            className = cx(className, styles.filled);
        }

        placeholder = required && placeholder ? `${placeholder} *` : placeholder || '';

        return (
            <div className={className}>
                <input
                    ref={forwardedRef}
                    className={
                        !this.props.isPristine() && !this.props.isValid() ? styles.active : ''
                    }
                    id={id}
                    type={type || 'text'}
                    name={name}
                    disabled={disabled}
                    value={value || mask}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onChange={this.handleChange}
                    autoComplete={autoComplete}
                    maxLength={maxLength}
                    pattern={pattern}
                    required={required}
                />
                {type !== 'hidden' && (
                    <label id={`label-${id || name}`} htmlFor={name}>
                        {placeholder}
                    </label>
                )}

                {icon && <Icon className={cx(styles.inputIcon, iconClassName)} icon={icon} />}

                {this.renderErrorMessage()}
            </div>
        );
    }
}

export default React.forwardRef((props: InputProps, ref: any) => {
    return <Input {...props} forwardedRef={ref} />;
});
